import baseRoute from '../baseRoute';

export type * from './queryParams';
export type * from './viewModel';

type BaseRouteDefinition = `${typeof baseRoute}/fieldReportTypes/reports/${string | ':code'}/download`;
type QueryRouteDefinition = `${typeof baseRoute}/fieldReportTypes/reports/${string | ':code'}/download?isForCustomer=${boolean}`;

type RouteDefinition = BaseRouteDefinition | QueryRouteDefinition;

export const ROUTE: RouteDefinition = `${baseRoute}/fieldReportTypes/reports/:code/download`;

export const URL = (code: string, isForCustomer?: boolean): RouteDefinition =>
	`${baseRoute}/fieldReportTypes/reports/${code}/download${isForCustomer === undefined ? '' : `?isForCustomer=${isForCustomer}` as const}`;
